import BolideAssistant from '@/components/BolideAssistant/BolideAssistant.vue';

export default {
  name: "AssistantStandaloneView",

  components: {
    BolideAssistant,
  },

  methods: {
    go_back() {
      // Closes the tab if it was opened via window.open() (script-opened
      // tabs can close themselves); browsers ignore this otherwise, so
      // fall back to sending the user back to the dashboard in-tab.
      window.close();
      this.$router.push('/home');
    },
  },
};
